module.exports = __webpack_public_path__ + "media/images/clients/blocked_info_icon-33a592208f12a303a5841d5fdd654c06.svg";